module.exports = __webpack_public_path__ + "static/media/email.f2ea63c8.svg";